import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SetSquareIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M7.9 3.7a8 8 0 0 0-4.7 5.6v.7c0 1.5 1.2 2.8 2.8 2.8h15a2 2 0 0 1 2 2v6.5c0 1-.8 1.7-1.7 1.7H5.5C3 23 1 21 1 18.5v-7.4a10.1 10.1 0 0 1 20.3 0h-2a8 8 0 0 0-5-7.4l.4.6c.7 1.8 1.1 4.2 1.1 6.8h-2a17 17 0 0 0-1-6c-.3-.8-.6-1.4-1-1.7-.3-.3-.5-.4-.7-.4-.1 0-.4 0-.7.4L9.4 5a17 17 0 0 0-1 6.1h-2A18.9 18.9 0 0 1 8 3.7Zm1.5 12.8V21h2.5v-2.6a1 1 0 1 1 2 0V21h2.6v-4.5a1 1 0 0 1 2 0V21H21v-6.2H6c-1.1 0-2.2-.4-3-1v4.7C3 19.9 4.1 21 5.5 21h1.9v-4.5a1 1 0 0 1 2 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default SetSquareIcon;
